/**
 * App Store screenshot play backgrounds from cropped IPHONE_BACKGROUND ad resources.
 * Use the stored S3 image URL — the object key UUID is not the same as the admin resource id.
 */

/** Cropped 1290×2796 JPEGs, in screenshot order 01 / 02 / 03 / 05 / 06 / 08. */
export const SCREENSHOT_IPHONE_BG_CATALOG = {
    iphone_1:
        "https://puzzleinteract-images.s3.us-east-1.amazonaws.com/ad/iphone/background/e7ad1fe3-aa52-4083-bad7-d7f25234d336.jpg",
    iphone_2:
        "https://puzzleinteract-images.s3.us-east-1.amazonaws.com/ad/iphone/background/a68ac79d-ba0e-486b-a96d-b46fb653444b.jpg",
    iphone_3:
        "https://puzzleinteract-images.s3.us-east-1.amazonaws.com/ad/iphone/background/f21d4fee-7a12-4ca0-a243-19918ffc9237.jpg",
    iphone_4:
        "https://puzzleinteract-images.s3.us-east-1.amazonaws.com/ad/iphone/background/0cc83b55-c53a-4356-9b29-5bc8bcfa7d05.jpg",
    iphone_5:
        "https://puzzleinteract-images.s3.us-east-1.amazonaws.com/ad/iphone/background/9a5bf69d-fa27-462a-a02f-8f7a86f1003c.jpg",
    iphone_6:
        "https://puzzleinteract-images.s3.us-east-1.amazonaws.com/ad/iphone/background/e127263d-c293-43f0-b343-462f4bf04a89.jpg",
};

export const IPHONE_BG_PLAY_FALLBACK = "#0f172a";

export const IPHONE_BG_PLAY_WASH =
    "linear-gradient(180deg, rgba(2, 6, 23, 0.10) 0%, rgba(2, 6, 23, 0.18) 48%, rgba(2, 6, 23, 0.42) 100%)";

export function isScreenshotIphoneBackgroundKey(key) {
    return Boolean(key && SCREENSHOT_IPHONE_BG_CATALOG[key]);
}

/**
 * Http story photos win. Catalog keys fill the phone when the story photo is missing.
 */
export function screenshotIphoneBgSrc(key, fallbackKey = "iphone_1") {
    if (typeof key === "string" && /^https?:\/\//i.test(key)) return key;
    return SCREENSHOT_IPHONE_BG_CATALOG[key] || SCREENSHOT_IPHONE_BG_CATALOG[fallbackKey] || "";
}
